import { useRegisterSW } from 'virtual:pwa-register/react';

export function RegisterPwa() {
  const { needRefresh: [needRefresh, setNeedRefresh], updateServiceWorker } = useRegisterSW();
  if (!needRefresh) return null;
  return (
    <div role="status" className="pwa-update">
      <span>Uma nova versão do KemiControl está pronta.</span>
      <button className="primary-button" onClick={() => void updateServiceWorker(true)}>Atualizar</button>
      <button className="text-button" onClick={() => setNeedRefresh(false)}>Depois</button>
    </div>
  );
}

